import { __assign, __rest } from "tslib";
import classNames from 'classnames';
import * as React from 'react';
var ListItemContent = function (props) {
    var _a = props.prefix, prefix = _a === void 0 ? 'cn-ui-m-' : _a, className = props.className, others = __rest(props, ["prefix", "className"]);
    return (React.createElement("div", __assign({ className: classNames("".concat(prefix, "list-item-content"), className) }, others)));
};
export default ListItemContent;
